import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const UserEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        UserName: '',
        Email: '',
        ContactNumber: '',
        isSubmit: false
    });

    useEffect(() => {
        fetchData('UserApi', `/UserDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching User Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));

        // Update UserName based on the combination of FirstName and LastName
        if (name === 'FirstName' || name === 'LastName') {
            const updatedUserName = `${formData.FirstName.toLowerCase()}_${formData.LastName.toLowerCase()}`;
            const limitedUserName = updatedUserName.slice(0, 15);
            setFormData((prevFormData) => ({
                ...prevFormData,
                UserName: limitedUserName,
            }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.isSubmit) {
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        // Validate form data here if needed

        updateData('UserApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/UserIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h6 className="uppercase productHead flex-grow linkcolor" style={{ fontFamily: 'Times New Roman', color: 'black' }}>User - Edit</h6>
                    {/* <div className="button-container-2">
                        <span className="mas">UPDATE</span>
                        <button className="mr-2"
                            onClick={() => handleChange({ target: { name: 'isSubmit', value: true } })}
                        >UPDATE</button>
                    </div>
                    <div className="button-container-3">
                        <span className="mas">CANCEL</span>
                        <button type="button" onClick={() => history.push('/UserIndex')} className="linkcolor">
                            CANCEL
                        </button>
                    </div> */}
                    <Tooltip title="Exit">
                        <Link to="/UserIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                Exit <ExitToAppIcon />
                            </Button>
                        </Link>
                    </Tooltip>


                    <Tooltip title="SAVE">

                        <Button onClick={handleSubmit} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "UPDATE"} <CheckCircleIcon />
                        </Button>

                    </Tooltip>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            First Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.FirstName}
                            name='FirstName'
                            onChange={handleChange}
                            type="text" placeholder="Enter First Name"
                            maxLength={30}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Last Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.LastName}
                            name='LastName'
                            onChange={handleChange}
                            type="text" placeholder="Enter Last Name"
                            maxLength={30}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            User Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.UserName}
                            name='UserName'
                            onChange={handleChange}
                            type="text" placeholder="Enter User Name"
                            readOnly
                        />
                    </div>
                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Contact Number
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.ContactNumber}
                            name='ContactNumber'
                            onChange={handleChange}
                            type="text" placeholder="Enter Contact Number"
                            maxLength={15}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Email
                            <span className="text-red-500">*</span>
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                            value={formData.Email}
                            name='Email'
                            onChange={handleChange}
                            type="text" placeholder="Enter Email"
                            maxLength={40}
                        />
                    </div>

                </div>
            </form>
        </div>
    );
};

export default UserEdit;
